import { Dispatch, SetStateAction } from "react"

export interface Camouflage {
    id: string,
    name: string,
    img: string
}

export interface mixCamouflage {
    mix_id: string,
    camouflages: Camouflage[]
}

export type CamouflageOwnerType =  'profile' | 'team' 

export const camouflageKeys = {
    profile: ["userCamouflages"],
    team: ["teamCamouflages"]
}